module.exports = __webpack_public_path__ + "img/img-de7511f2.9887a6df.png";